

import React from 'react'

export default function Loading() {
    return (
        <>
            <div 
            className='text-primary bg-white h-100 w-100 d-flex position-fixed justify-content-center align-items-center'
            style={{
                zIndex:"9999"
            }}
            >
                <div className="spinner-grow" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </>
    )
}


